var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NLink',{class:_vm.css.root,attrs:{"to":_vm.to}},[_vm._t("default"),_vm._v(" "),_c('div',{class:_vm.css.icon},[_c('SvgIcon',{attrs:{"name":_vm.icon}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }